module.exports = __webpack_public_path__ + "static/media/default-team-logo-basketball.28629265.png";